// extracted by mini-css-extract-plugin
export default {"root":"soX+THU","root_error":"_9om9nNy","container":"XiV57rt","audioPlayer":"_9pwDT1N"};